import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { logError, logFatalError } from '@databases/logs';
import { serializeError } from '@databases/utils/utils';

/**
 * Handles logging a fatal error when databases is initialized and fails.
 */
export function handleFatalErrorLogging(error: any) {
  logError(error);

  let formattedError:
    | { name?: string; message?: string; stack?: string; code?: string }
    | undefined = undefined;

  if (error instanceof Error) {
    logFatalError(error);

    const serializedError = serializeError(error);

    formattedError = {
      name: serializedError.name,
      message: serializedError.message,
      stack: serializedError.stack,
      code: serializedError.code,
    };
  }

  GlobalPageLoadExperience.failure({
    metadata: { error: formattedError },
    force: true,
  });
}
